import { StyledButton } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContent = styled.div`
  padding: 5rem 4rem 4.6rem;
  text-align: center;
  position: relative;
`;

export const StyledWrapper = styled.div`
  position: relative;
  overflow: hidden;
  &:after {
    content: '';
    background: radial-gradient(50% 50% at 50% 50%, #719cf9 0%, rgba(21, 28, 43, 0) 100%);
    position: absolute;
    bottom: -11rem;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 20rem;
    z-index: 0;
    opacity: 0.8;
  }
`;

export const StyledInfluencerRedirectButton = styled(StyledButton)`
  position: relative;
  z-index: 5;
`;
